import React, { useState, useRef, useEffect } from 'react'
import SectionCarousel from '../../landingPage/SectionCarousel';
import Section from '../../landingPage/Section';
import {HighPrecisionScans, Platform, Branding, KnowledgePortal, AISoftware, GrayD} from '../../../images/index'
import Slides from '../../../components/landingPage/Cards/SlideCards'
import ProcessSection from './ProcessSection';
import useWindowSize from '../../../hooks/useWindowSize';

function WorkflowSection() {

  const size = useWindowSize();

  const [ activeSlide, setActiveSlide ] = useState(0);
  const [ imageSize, setImageSize ] = useState({
    height: null,
  })

  const imgRef = useRef(null);

  useEffect(() => {
    let initialHeight;
    if (size.width >= size.tailwind.lg) {
      initialHeight = '376px';
    } else {
      initialHeight = '292px';
    }
    setImageSize({
      height: imgRef?.current?.offsetHeight || initialHeight,
    })
  }, [size])

  const IMG_STYLE = {
    transition:"all .5s linear",
    maxHeight:"350px",
  }
  
  const IMG_CONTAINER = {
    height: imageSize.height,
  }

  return (
    <div className="relative px-1 md:px-0 my-8 sm:my-28 w-full bg-gray-50">
      <h1 className={`text-center text-primary font-semibold text-2xl sm:text-4xl pb-12 bg-white`} >Our Workflow</h1>
      {/* <img alt='gray-background'src={GrayD} className="absolute z-0 right-0 transform translate-y-64"/> */}
      <Section title='Our Tools' subtitle='XiViX tools facilitate communication, investigations & diagnosis. All XiViX partners have access to these proprietary tools developed by our experts.' className="bg-gray-50 z-10 py-4 md:py-12">
        <div className="flex flex-col-reverse lg:flex-row lg:p-10 md:w-full lg:px-28 items-center bg-greyD">
          <div className="w-full md:min-w-1/2 flex lg:justify-end justify-center py-4 lg:py-10 z-50">
            <SectionCarousel 
              activeSlide={activeSlide} 
              setActiveSlide={setActiveSlide} 
              slideCounter={5}
            >
              <Slides title="XiViX Platform">
                The XiViX Platform facilitates digital communication & collaboration between all XiViX partners and patients.
                <ul className="mt-4">
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Access patient files on any device</li>
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Integrated scheduling & appointments</li>
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Simplified payments for partners & patients</li>
                </ul>
              </Slides>
              <Slides title="High-precision Scans">
                3D Scanners (Intra-Oral, Face & CBCT X-ray) prevent repeat impressions, unlike traditional workflows.
                <ul className="mt-4">
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Quicker diagnosis</li>
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Better patient interactions</li>
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Reduced chair time & costs</li>
                </ul>
              </Slides>
              <Slides title="AI-software & Engineering">
              XiViX proprietary AI-software & engineering enables high accuracy in prosthesis designing & tooth preparations.
              <ul className="mt-4">
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Smile simulations for patients</li>
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Design & manufacture of prosthesis</li>
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Assisted tooth preparations</li>
              </ul>
              </Slides>
              <Slides title="Branding">
              As an organization & network of professionals, XiViX has the power and bandwidth to market our services better.
              <ul className="mt-4">
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Increased patient flow</li>
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Exclusive services & products for XiViX patients</li>
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Global reach</li>
              </ul>
              </Slides>
              <Slides title="XiViX Knowledge Portal">
                XiViX brings together global dental experts to leverage the power of network and build a practice you are proud of.
                <ul className="mt-4">
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Trainings for new partners</li>
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Trainings & updates on new technhology</li>
                  <li><span className="text-primary font-extrabold mr-1">&#x2022;</span> Webinars on the latest procedures & research</li>
              </ul>
              </Slides>
            </SectionCarousel>
          </div>
          {/*<div className="relative w-full md:min-w-1/2 flex justify-center h-auto" style={IMG_CONTAINER}>*/}
          <div className="relative w-full min-w-1/2 flex justify-center lg:justify-start" style={IMG_CONTAINER}>
            <img alt='platform' ref={imgRef} id="img1" className={`absolute object-contain  ${activeSlide===0 ? "opacity-100" : "opacity-0"}`} src={Platform} style={IMG_STYLE}/>
            <img alt='scans' id="img2" className={`absolute object-contain  ${activeSlide===1 ? "opacity-100" : "opacity-0"}`} src={HighPrecisionScans} style={IMG_STYLE}/>
            <img alt='software' id="img3" className={`absolute object-contain  ${activeSlide===2 ? "opacity-100" : "opacity-0"}`} src={AISoftware} style={IMG_STYLE}/>
            <img alt='branding' id="img4" className={`absolute object-contain  ${activeSlide===3 ? "opacity-100" : "opacity-0"}`} src={Branding} style={IMG_STYLE}/>
            <img alt='knowledge-portal' id="img5" className={`absolute object-contain  ${activeSlide===4 ? "opacity-100" : "opacity-0"}`} src={KnowledgePortal} style={IMG_STYLE}/>
          </div>
        </div>
      </Section>
      <ProcessSection/>
    </div>
    
    )
}

export default WorkflowSection;